module.exports = __webpack_public_path__ + "img/hc_pro_six_5.ac35f471.jpg";